// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/froala-editor/css/froala_style.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/non.geist/font-faces/sans-var.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
    :root {
        --background: 225, 80%, 98.04%;
        --foreground: 0, 0%, 100%;
        --card: 0 0% 100%;
        --card-foreground: 222.2 84% 4.9%;

        --popover: 0 0% 100%;
        --popover-foreground: 222.2 84% 4.9%;

        --primary: 210.34, 100%, 17.45%;
        --primary-foreground: 210 40% 98%;

        --secondary: 210 40% 96.1%;
        --secondary-foreground: 222.2 47.4% 11.2%;

        --muted: 210 40% 96.1%;
        --muted-foreground: 215.4 16.3% 46.9%;

        --accent: 210 40% 96.1%;
        --accent-foreground: 222.2 47.4% 11.2%;

        --destructive: 0 84.2% 60.2%;
        --destructive-foreground: 210 40% 98%;

        --border: 214.3 31.8% 91.4%;
        --input: 214.3 31.8% 91.4%;
        --ring: 222.2 84% 4.9%;

        --radius: 0.5rem;
        --text-color: 0, 0%, 20.39%;
        --font-sans: "Geist Variable";
        --font-mono: "Geist Mono Variable";
    }

    .dark {
        --background: 0, 0%, 12.94%;
        --foreground: 0, 0%, 21.18%;

        --card: 222.2 84% 4.9%;
        --card-foreground: 210 40% 98%;

        --popover: 222.2 84% 4.9%;
        --popover-foreground: 210 40% 98%;

        --primary: 195.22, 59.29%, 77.84%;
        --primary-foreground: 222.2 47.4% 11.2%;

        --secondary: 154.94, 39.7%, 60.98%;
        --secondary-foreground: 210 40% 98%;

        --muted: 217.2 32.6% 17.5%;
        --muted-foreground: 215 20.2% 65.1%;

        --accent: 217.2 32.6% 17.5%;
        --accent-foreground: 210 40% 98%;

        --destructive: 350.12, 78.85%, 59.22%;
        --destructive-foreground: 210 40% 98%;

        --border: 217.2 32.6% 17.5%;
        --input: 217.2 32.6% 17.5%;
        --ring: 212.7 26.8% 83.9%;
    }
}

@layer base {
    * {
        @apply border-border;
    }

    body {
        @apply bg-background;
    }

    .editor-grid {
        @apply grid gap-4 items-start min-h-0 min-w-0;
        @apply p-4 pt-0 w-full relative;

        grid-template-columns: 16rem 1fr;
    }

    @screen 2xl {
        .editor-grid-preview {
            grid-template-columns: 16rem 1fr 1fr;
        }
    }
}

/*PACKAGE OVERWRITES*/

#pdf-renderer {
    max-height: calc(100vh - 150px) !important;
}

#pdf-download {
    display: none !important;
}

#pdf-toggle-pagination {
    display: none !important;
}

#welcome-wrapper.body.more-or-less {
    height: 0 !important;
}

.fr-highlight-change {
    background-color: transparent !important;
    color: #34a853 !important;
    font-weight: bold !important;
    opacity: 1 !important;
    cursor: text !important;

    p {
        opacity: 1 !important;
        background-color: transparent !important;
    }

    &.rejected {
        background-color: lightskyblue !important;
        opacity: 1 !important;
    }

    &.reinstate {
        background-color: transparent !important;

        & .fr-tracking-deleted {
            background-color: transparent !important;
            text-decoration: none !important;
            font-weight: normal !important;
        }
    }

    &.highlight {
        background-color: yellow !important;
    }

    /* make sure all text elements in editor don't get nasty froala styling*/

    span,
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    blockquote,
    dd,
    div,
    dl,
    dt,
    figcaption,
    figure,
    hr,
    li,
    menu,
    ol,
    pre,
    ul {
        opacity: 1 !important;
        background-color: transparent !important;
    }

    &:hover {
        cursor: pointer;
    }
}

.highlight {
    background-color: yellow !important;
}

.cl-highlight {
    border: 1px solid #3767d6 !important;
}

.fr-tracking-deleted {
    background-color: transparent !important;
    color: #ff0000 !important;
    text-decoration: line-through;
    opacity: 1;
    font-weight: normal !important;
    cursor: pointer !important;

    &.highlight {
        background-color: yellow !important;
    }

    &.hide-highlight {
        background-color: white !important;
    }
}

* .tc-hidden {
    opacity: 0 !important;

    &.highlight {
        opacity: 1 !important;
    }

    &.hide-highlight {
        background-color: white !important;
        color: white !important;
        opacity: 1 !important;
        z-index: 9999;
    }
}
.fr-box.fr-basic .fr-element.fr-view {
    font-family: "Lora", "serif";
    font-size: 13px;
}
.fr-view {
    a[data-recap-id] {
        display: inline-block;

        &:not([data-change-type], &[data-filled-in-recap="true"]) {
            background-color: #fff9c4;
            height: 1.25em;
            width: 5em;
            color: #ffffff;
            border-radius: 4px;
        }

        &:hover {
            cursor: pointer;
            background-color: #3767d6 !important;
            border-radius: 4px;
        }

        &[data-change-type] {
            &:hover {
                background-color: #34a85320 !important;
                outline: 4px solid #34a85320;
            }
        }

        &.highlight {
            background-color: #3767d6 !important;
        }
    }
}

table td[data-is-line-number] {
    * .fr-tracking-deleted {
        color: #414141 !important;
        text-decoration: none !important;
    }
}

.fr-view table {
    table-layout: fixed;
}

.fr-view table td,
.fr-view table th {
    word-wrap: break-word;
}

div.page-break {
    display: none;
}

@media (max-width: 1440px) {
    .fr-box.fr-document .fr-wrapper {
        min-width: 800px !important;
    }

    .fr-box.fr-document .fr-wrapper .fr-element {
        width: auto !important;
    }
}

/* hacky hacky for custom button in rider editor */
.fr-toolbar [id^="newMark-"] svg path {
    transform: scale(0.875) translate(3px, 1px) !important;
}

.fr-toolbar [id^="revertMark-"] svg path {
    transform: scale(1.25) translate(-3px, -3px) !important;
}

.fr-toolbar [id^="clauseCut-"] svg path {
    transform: scale(1.25) translate(2px, 1px) !important;
}

.fr-toolbar [id^="placeholder-"] svg path {
    fill: none !important;
    stroke: #333333;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.fr-view table.no-borders td,
.fr-view table.no-borders th {
    border: none !important;
}

table.outside-margins {
    margin-left: -2cm;
    width: calc(100% + 4cm);
    max-width: calc(100% + 4cm);
}

div.cols-2 {
    columns: 2;
    column-gap: 2rem;
}

img.img-outside-margins {
    margin-left: -2cm !important;
}

img.img-full-max-width {
    width: auto;
    max-width: 100%;
    min-width: 21cm;
}

.line-number {
    white-space: nowrap !important;
    color: #999 !important;
    text-align: right !important;
    font-feature-settings: "tnum" !important;
    font-variant-numeric: tabular-nums !important;
    user-select: none;
}
tr .line-number:first-child {
    padding-right: 16px !important;
}
tr .line-number:nth-child(2):not(:last-child) {
    padding-right: 16px !important;
}
tr .line-number:last-child {
    padding-left: 16px !important;
}
.line-number > span {
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
    user-select: none;
}
.fr-box.fr-document .fr-wrapper .fr-element {
    padding: 12mm !important;
    width: 210mm !important;
    line-height: 1.3;
    table.outside-margins {
        margin-left: -12mm;
        width: calc(100% + 24mm);
        max-width: calc(100% + 24mm);
    }
}

.justify-last {
    text-align: justify;
    text-align-last: justify;
}

.multiple-pages {
    .fr-box.fr-document .fr-wrapper .fr-element {
        padding: 0 !important;
        width: 210mm !important;
    }
}

ol,
ul {
    padding: revert;
    margin: auto;
}

ol li {
    list-style: list-item;
}

ul li {
    list-style: circle;
}

.zoom-75 {
    zoom: 0.75;
}
.zoom-100 {
    zoom: 1;
}

.placeholder-tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 3px;
    white-space: nowrap;
    margin-bottom: 5px;
    font-size: 12px;
    z-index: 4;
}

.remove-placeholder {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: red;
    color: white;
    border: none;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    line-height: 1;
    z-index: 4;
}
`, "",{"version":3,"sources":["webpack://./src/assets/index.css"],"names":[],"mappings":"AAEA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;IACI;QACI,8BAA8B;QAC9B,yBAAyB;QACzB,iBAAiB;QACjB,iCAAiC;;QAEjC,oBAAoB;QACpB,oCAAoC;;QAEpC,+BAA+B;QAC/B,iCAAiC;;QAEjC,0BAA0B;QAC1B,yCAAyC;;QAEzC,sBAAsB;QACtB,qCAAqC;;QAErC,uBAAuB;QACvB,sCAAsC;;QAEtC,4BAA4B;QAC5B,qCAAqC;;QAErC,2BAA2B;QAC3B,0BAA0B;QAC1B,sBAAsB;;QAEtB,gBAAgB;QAChB,2BAA2B;QAC3B,6BAA6B;QAC7B,kCAAkC;IACtC;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;;QAE3B,sBAAsB;QACtB,8BAA8B;;QAE9B,yBAAyB;QACzB,iCAAiC;;QAEjC,iCAAiC;QACjC,uCAAuC;;QAEvC,kCAAkC;QAClC,mCAAmC;;QAEnC,0BAA0B;QAC1B,mCAAmC;;QAEnC,2BAA2B;QAC3B,gCAAgC;;QAEhC,qCAAqC;QACrC,qCAAqC;;QAErC,2BAA2B;QAC3B,0BAA0B;QAC1B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,6CAA6C;QAC7C,+BAA+B;;QAE/B,gCAAgC;IACpC;;IAEA;QACI;YACI,oCAAoC;QACxC;IACJ;AACJ;;AAEA,qBAAqB;;AAErB;IACI,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,4BAA4B;IAC5B,qBAAqB;IACrB,uBAAuB;;IAEvB;QACI,qBAAqB;QACrB,wCAAwC;IAC5C;;IAEA;QACI,yCAAyC;QACzC,qBAAqB;IACzB;;IAEA;QACI,wCAAwC;;QAExC;YACI,wCAAwC;YACxC,gCAAgC;YAChC,8BAA8B;QAClC;IACJ;;IAEA;QACI,mCAAmC;IACvC;;IAEA,wEAAwE;;IAExE;;;;;;;;;;;;;;;;;;;;;QAqBI,qBAAqB;QACrB,wCAAwC;IAC5C;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,6BAA6B;IAC7B,UAAU;IACV,8BAA8B;IAC9B,0BAA0B;;IAE1B;QACI,mCAAmC;IACvC;;IAEA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI,qBAAqB;;IAErB;QACI,qBAAqB;IACzB;;IAEA;QACI,kCAAkC;QAClC,uBAAuB;QACvB,qBAAqB;QACrB,aAAa;IACjB;AACJ;AACA;IACI,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI;QACI,qBAAqB;;QAErB;YACI,yBAAyB;YACzB,cAAc;YACd,UAAU;YACV,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,oCAAoC;YACpC,kBAAkB;QACtB;;QAEA;YACI;gBACI,sCAAsC;gBACtC,4BAA4B;YAChC;QACJ;;QAEA;YACI,oCAAoC;QACxC;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,gCAAgC;IACpC;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,kDAAkD;AAClD;IACI,sDAAsD;AAC1D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;IAC5B,wCAAwC;IACxC,6CAA6C;IAC7C,iBAAiB;AACrB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB;QACI,kBAAkB;QAClB,wBAAwB;QACxB,4BAA4B;IAChC;AACJ;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;AACA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;AACd","sourcesContent":["@import \"froala-editor/css/froala_style.min.css\";\n@import url(\"non.geist\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    :root {\n        --background: 225, 80%, 98.04%;\n        --foreground: 0, 0%, 100%;\n        --card: 0 0% 100%;\n        --card-foreground: 222.2 84% 4.9%;\n\n        --popover: 0 0% 100%;\n        --popover-foreground: 222.2 84% 4.9%;\n\n        --primary: 210.34, 100%, 17.45%;\n        --primary-foreground: 210 40% 98%;\n\n        --secondary: 210 40% 96.1%;\n        --secondary-foreground: 222.2 47.4% 11.2%;\n\n        --muted: 210 40% 96.1%;\n        --muted-foreground: 215.4 16.3% 46.9%;\n\n        --accent: 210 40% 96.1%;\n        --accent-foreground: 222.2 47.4% 11.2%;\n\n        --destructive: 0 84.2% 60.2%;\n        --destructive-foreground: 210 40% 98%;\n\n        --border: 214.3 31.8% 91.4%;\n        --input: 214.3 31.8% 91.4%;\n        --ring: 222.2 84% 4.9%;\n\n        --radius: 0.5rem;\n        --text-color: 0, 0%, 20.39%;\n        --font-sans: \"Geist Variable\";\n        --font-mono: \"Geist Mono Variable\";\n    }\n\n    .dark {\n        --background: 0, 0%, 12.94%;\n        --foreground: 0, 0%, 21.18%;\n\n        --card: 222.2 84% 4.9%;\n        --card-foreground: 210 40% 98%;\n\n        --popover: 222.2 84% 4.9%;\n        --popover-foreground: 210 40% 98%;\n\n        --primary: 195.22, 59.29%, 77.84%;\n        --primary-foreground: 222.2 47.4% 11.2%;\n\n        --secondary: 154.94, 39.7%, 60.98%;\n        --secondary-foreground: 210 40% 98%;\n\n        --muted: 217.2 32.6% 17.5%;\n        --muted-foreground: 215 20.2% 65.1%;\n\n        --accent: 217.2 32.6% 17.5%;\n        --accent-foreground: 210 40% 98%;\n\n        --destructive: 350.12, 78.85%, 59.22%;\n        --destructive-foreground: 210 40% 98%;\n\n        --border: 217.2 32.6% 17.5%;\n        --input: 217.2 32.6% 17.5%;\n        --ring: 212.7 26.8% 83.9%;\n    }\n}\n\n@layer base {\n    * {\n        @apply border-border;\n    }\n\n    body {\n        @apply bg-background;\n    }\n\n    .editor-grid {\n        @apply grid gap-4 items-start min-h-0 min-w-0;\n        @apply p-4 pt-0 w-full relative;\n\n        grid-template-columns: 16rem 1fr;\n    }\n\n    @screen 2xl {\n        .editor-grid-preview {\n            grid-template-columns: 16rem 1fr 1fr;\n        }\n    }\n}\n\n/*PACKAGE OVERWRITES*/\n\n#pdf-renderer {\n    max-height: calc(100vh - 150px) !important;\n}\n\n#pdf-download {\n    display: none !important;\n}\n\n#pdf-toggle-pagination {\n    display: none !important;\n}\n\n#welcome-wrapper.body.more-or-less {\n    height: 0 !important;\n}\n\n.fr-highlight-change {\n    background-color: transparent !important;\n    color: #34a853 !important;\n    font-weight: bold !important;\n    opacity: 1 !important;\n    cursor: text !important;\n\n    p {\n        opacity: 1 !important;\n        background-color: transparent !important;\n    }\n\n    &.rejected {\n        background-color: lightskyblue !important;\n        opacity: 1 !important;\n    }\n\n    &.reinstate {\n        background-color: transparent !important;\n\n        & .fr-tracking-deleted {\n            background-color: transparent !important;\n            text-decoration: none !important;\n            font-weight: normal !important;\n        }\n    }\n\n    &.highlight {\n        background-color: yellow !important;\n    }\n\n    /* make sure all text elements in editor don't get nasty froala styling*/\n\n    span,\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    blockquote,\n    dd,\n    div,\n    dl,\n    dt,\n    figcaption,\n    figure,\n    hr,\n    li,\n    menu,\n    ol,\n    pre,\n    ul {\n        opacity: 1 !important;\n        background-color: transparent !important;\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n}\n\n.highlight {\n    background-color: yellow !important;\n}\n\n.cl-highlight {\n    border: 1px solid #3767d6 !important;\n}\n\n.fr-tracking-deleted {\n    background-color: transparent !important;\n    color: #ff0000 !important;\n    text-decoration: line-through;\n    opacity: 1;\n    font-weight: normal !important;\n    cursor: pointer !important;\n\n    &.highlight {\n        background-color: yellow !important;\n    }\n\n    &.hide-highlight {\n        background-color: white !important;\n    }\n}\n\n* .tc-hidden {\n    opacity: 0 !important;\n\n    &.highlight {\n        opacity: 1 !important;\n    }\n\n    &.hide-highlight {\n        background-color: white !important;\n        color: white !important;\n        opacity: 1 !important;\n        z-index: 9999;\n    }\n}\n.fr-box.fr-basic .fr-element.fr-view {\n    font-family: \"Lora\", \"serif\";\n    font-size: 13px;\n}\n.fr-view {\n    a[data-recap-id] {\n        display: inline-block;\n\n        &:not([data-change-type], &[data-filled-in-recap=\"true\"]) {\n            background-color: #fff9c4;\n            height: 1.25em;\n            width: 5em;\n            color: #ffffff;\n            border-radius: 4px;\n        }\n\n        &:hover {\n            cursor: pointer;\n            background-color: #3767d6 !important;\n            border-radius: 4px;\n        }\n\n        &[data-change-type] {\n            &:hover {\n                background-color: #34a85320 !important;\n                outline: 4px solid #34a85320;\n            }\n        }\n\n        &.highlight {\n            background-color: #3767d6 !important;\n        }\n    }\n}\n\ntable td[data-is-line-number] {\n    * .fr-tracking-deleted {\n        color: #414141 !important;\n        text-decoration: none !important;\n    }\n}\n\n.fr-view table {\n    table-layout: fixed;\n}\n\n.fr-view table td,\n.fr-view table th {\n    word-wrap: break-word;\n}\n\ndiv.page-break {\n    display: none;\n}\n\n@media (max-width: 1440px) {\n    .fr-box.fr-document .fr-wrapper {\n        min-width: 800px !important;\n    }\n\n    .fr-box.fr-document .fr-wrapper .fr-element {\n        width: auto !important;\n    }\n}\n\n/* hacky hacky for custom button in rider editor */\n.fr-toolbar [id^=\"newMark-\"] svg path {\n    transform: scale(0.875) translate(3px, 1px) !important;\n}\n\n.fr-toolbar [id^=\"revertMark-\"] svg path {\n    transform: scale(1.25) translate(-3px, -3px) !important;\n}\n\n.fr-toolbar [id^=\"clauseCut-\"] svg path {\n    transform: scale(1.25) translate(2px, 1px) !important;\n}\n\n.fr-toolbar [id^=\"placeholder-\"] svg path {\n    fill: none !important;\n    stroke: #333333;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n\n.fr-view table.no-borders td,\n.fr-view table.no-borders th {\n    border: none !important;\n}\n\ntable.outside-margins {\n    margin-left: -2cm;\n    width: calc(100% + 4cm);\n    max-width: calc(100% + 4cm);\n}\n\ndiv.cols-2 {\n    columns: 2;\n    column-gap: 2rem;\n}\n\nimg.img-outside-margins {\n    margin-left: -2cm !important;\n}\n\nimg.img-full-max-width {\n    width: auto;\n    max-width: 100%;\n    min-width: 21cm;\n}\n\n.line-number {\n    white-space: nowrap !important;\n    color: #999 !important;\n    text-align: right !important;\n    font-feature-settings: \"tnum\" !important;\n    font-variant-numeric: tabular-nums !important;\n    user-select: none;\n}\ntr .line-number:first-child {\n    padding-right: 16px !important;\n}\ntr .line-number:nth-child(2):not(:last-child) {\n    padding-right: 16px !important;\n}\ntr .line-number:last-child {\n    padding-left: 16px !important;\n}\n.line-number > span {\n    -moz-user-select: -moz-none;\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n}\n.fr-box.fr-document .fr-wrapper .fr-element {\n    padding: 12mm !important;\n    width: 210mm !important;\n    line-height: 1.3;\n    table.outside-margins {\n        margin-left: -12mm;\n        width: calc(100% + 24mm);\n        max-width: calc(100% + 24mm);\n    }\n}\n\n.justify-last {\n    text-align: justify;\n    text-align-last: justify;\n}\n\n.multiple-pages {\n    .fr-box.fr-document .fr-wrapper .fr-element {\n        padding: 0 !important;\n        width: 210mm !important;\n    }\n}\n\nol,\nul {\n    padding: revert;\n    margin: auto;\n}\n\nol li {\n    list-style: list-item;\n}\n\nul li {\n    list-style: circle;\n}\n\n.zoom-75 {\n    zoom: 0.75;\n}\n.zoom-100 {\n    zoom: 1;\n}\n\n.placeholder-tooltip {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #333;\n    color: #fff;\n    padding: 5px;\n    border-radius: 3px;\n    white-space: nowrap;\n    margin-bottom: 5px;\n    font-size: 12px;\n    z-index: 4;\n}\n\n.remove-placeholder {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    background-color: red;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    line-height: 1;\n    z-index: 4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
